import React, { useState } from 'react';
import { Button, Icon, themes, Loader } from '@digitools/honest-react';
import useAuthentication from "src/hooks/useAuthentication";
import useTranslate from "src/hooks/useTranslate";
import { downloadCliConfirmationPdf } from "../../api/CliApiCalls";
import { CliText } from 'src/packages/cli/constants/CliText';
const DownloadAndPrint = (props) => {
    const { setErrorMessage, cliContextClone } = props;
    const { t } = useTranslate();
    const { authHeader } = useAuthentication();
    const [isLoading, setIsLoading] = useState(false);
    const handleDownload = async () => {
        setErrorMessage('');
        setIsLoading(true);
        try {
            await downloadCliConfirmationPdf(authHeader(), cliContextClone, setErrorMessage, t(CliText.downloadConfirmationError));
        }
        finally {
            setIsLoading(false);
        }
    };
    return (<Loader size='small' isShown={isLoading} data-testid='download-pdf-spinner'>
      <Button theme={themes.rebrand} type={'button'} disabled={isLoading} className={'p-0'} 
    //TODO: analytics call
    onClick={handleDownload} data-testid={'download-button'}>
        <Icon name={'pdf'} size='medium' color={'secondary'} style={{ marginRight: '0.5rem' }}/>
        {t(CliText.downloadConfirmationButton)}
      </Button>
    </Loader>);
};
export default DownloadAndPrint;
